import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1280px;
  padding: 32px 24px 48px;
  gap: 24px;

  @media (max-width: 768px) {
    padding: 24px 16px 40px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h1`
  margin: 0;
  color: #003644;
  font-size: 32px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: #4f6470;
  font-size: 16px;
  line-height: 1.5;
`;
